import {DesignDto, MemberDto} from "../generated/dashboard-client";
import {DESIGN_IN_USE_SECONDS} from "../util/constants";
import {DesignWithCycle} from "../util/types";

export interface ActiveCycle {
  name: string;
  endsLabel: string;
}

export function isInUse(d: DesignDto, member: MemberDto) {
  if (!d.inUseLastPingAt || !member.id) return false;
  return member.internalId !== d.inUseMemberId && (new Date().getTime() - d.inUseLastPingAt) < DESIGN_IN_USE_SECONDS * 1000;
}

export function getActiveCycle(d: DesignDto): ActiveCycle | null {
  const {activeCycleName, activeCycleEndDate} = d as DesignWithCycle;
  if (!activeCycleName || !activeCycleEndDate) return null;

  const [year, month, day] = activeCycleEndDate.split("-").map(Number);
  if (!year || !month || !day) return null;

  return {
    name: activeCycleName,
    endsLabel: new Date(year, month - 1, day).toLocaleDateString("en-US", {month: "short", day: "numeric"}),
  };
}
